import React, { useContext, useEffect } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Row, Col } from "react-bootstrap";
import PageLayout from "../../layouts/PageLayout";
import { getAllStates } from "../../APIs/SettingRequests";
import { LabelFieldComponent } from "../../components/fields";
import { PaginationComponent } from "../../components";
import { useParams } from "react-router-dom";
import PulseLoader from "react-spinners/PulseLoader";
import StatesTableComponent from "../../components/tables/StatesTableComponent";

export default function StatesListPage() {
    const {countryId} = useParams();
    
    const { t } = useContext(TranslatorContext);
    const [data, setData] = React.useState('');
    const [loading, setLoading] = React.useState(false);
    const [pagination, setPagination] = React.useState({});
    const [perPage, setPerPage] = React.useState(10);
    const [searchFilter, setSearchFilter] = React.useState('');

    
    const getAllDataAction = (page=1) => {
        getAllStates(countryId, page, perPage, searchFilter).then((res) => {
            setData(res.data.data);
            setPagination(res.data.pagination);
        }).catch((error) => {
        }).finally(() => {
        });
    }

    const handlePageClick = (selected) => {
        getAllDataAction(selected.selected + 1);
    }
   
    useEffect(() => {
        getAllDataAction();
    }, [perPage,searchFilter]);
    const thead = [t("id"), t("name"), t("action")];


    if(loading) {
        return (
            <div className="mc-spinner">
                <img className="pattern" src="images/pattern.webp" alt="pattern" />
                <img className="favicon" src="images/logo.webp" alt="logo" />
                <div className="mc-spinner-group">
                    <h3>Loading</h3>
                    <PulseLoader 
                        color="#0857f5"
                        loading={loading} 
                        size={8} 
                    /> 
                </div>
            </div>
        );
    }else{
        return (
            <PageLayout>
                <Row>
                    <Col xl={12}>
                        <div className="mc-card">
                            <div className='mc-breadcrumb'>
                                <h3 className="mc-breadcrumb-title">{t('states_list')}</h3>    
                            </div>
                        </div>
                    </Col>
                    
                    <Col xl={12}>
                        <div className="mc-card">
                            
                            <Row xs={1} sm={2} xl={4}>
                                <Col>
                                    <LabelFieldComponent
                                        label={t('show_by')}
                                        option={["10", "20", "50", "100"] }
                                        labelDir="label-col"
                                        fieldSize="w-100 h-md"
                                        onChange= {(e)=>{
                                            setPerPage(e.target.value);
                                        }}
                                    />
                                </Col>
                                
                                
                                <Col>
                                    <LabelFieldComponent
                                        type="search"
                                        label={t('search_by')}
                                        placeholder={t('id') + ' / ' + t('name') }
                                        labelDir="label-col"
                                        fieldSize="w-100 h-md"
                                        onChange={(e) => {
                                                setSearchFilter(e.target.value);
                                        }}
                                    />
                                </Col>
                            </Row>
                            
                            {
                                data.length>0 &&
                                <StatesTableComponent 
                                    thead={ thead }
                                    tbody={ data }
                                    refreshPage={ getAllDataAction }
                                />
                            }
                            
                            <PaginationComponent pagination={pagination} handlePageClick={handlePageClick}/>
                        </div>
                    </Col>
                </Row>
            </PageLayout>
        );
    }
    
}